export type BusinessType = "COMMERCE" | "EDUCATION" | "SOCIAL_MEDIA" | "ETC"

export const BusinessType = {
  COMMERCE: "COMMERCE",
  EDUCATION: "EDUCATION",
  SOCIAL_MEDIA: "SOCIAL_MEDIA",
  ETC: "ETC",
} as const

export type Plan = "NONE" | "FREE" | "PRO" | "ENTERPRISE"

export const Plan = {
  NONE: "NONE",
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
} as const

export interface RecommendedPricing {
  plan: Plan
  monthlyExpectedPrice: {
    minimum: number
    maximum: number
  }
  monthlyExpectedEvent: {
    minimum: number
    maximum: number
  }
}
